export const card3 = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '1.125rem',
      '::placeholder': {
        fontSize: '1.125rem',
        color: '#aab7c4',
      },
    },
  },
};

export const card2 = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '1.125rem',
      '::placeholder': {
        fontSize: '1.125rem',
        color: '#aab7c4',
      },
    },
  },
};

export const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '1.125rem',
      '::placeholder': {
        fontSize: '1.125rem',
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};
